import { isServiceVariantWithStaff } from '../dynamicPricing/dynamicPricing';
import { CalendarState } from '../../components/BookingCalendar/controller';
import { FilterTypes } from '../../components/BookingCalendar/ViewModel/filterViewModel/filterViewModel';
import {
  Service,
  ServiceType,
} from '@wix/ambassador-bookings-services-v2-service/types';
import {
  isServiceAutoAssignResourceAllowed,
  isServiceBookOnlineEnabled,
  isServicePendingApprovalFlow,
  isBookFlowSettingsEnabled as isBookFlowSettingsEnabledUtil,
  isCustomerMustChooseStaff,
  isAppointmentService,
} from '@wix/bookings-calendar-catalog-viewer-mapper';
import { Features } from '@wix/ambassador-bookings-v2-bookings-settings/types';
import { getStaffList } from '../slotAvailability/slotAvailability';
import { CalendarContext } from '../context/contextFactory';
import { TimeSlot } from '@wix/ambassador-bookings-availability-v2-time-slot/types';

export const isPendingApprovalFlow = (services: Service[]) => {
  return services.some((service) => isServicePendingApprovalFlow(service));
};

export const isCalendarFlow = (service: Service) =>
  !(service.type === ServiceType.COURSE) && isServiceBookOnlineEnabled(service);

export function isBookingsEnabled({
  servicesTypes,
  activeFeatures,
  isTemplateMode,
}: {
  servicesTypes: ServiceType[];
  activeFeatures: Features;
  isTemplateMode: boolean;
}): boolean {
  if (isTemplateMode) {
    return true;
  }

  return servicesTypes.every((serviceType) => {
    switch (serviceType) {
      case ServiceType.CLASS:
        return !!activeFeatures.bookingsGroups?.enabled;
      case ServiceType.APPOINTMENT:
        return !!activeFeatures.bookingsAppointments?.enabled;
      default:
        return true;
    }
  });
}

export const canAutoAssignStaff = ({
  state,
  context,
  selectableSlotsAtSelectedTime,
}: {
  state: CalendarState;
  context: CalendarContext;
  selectableSlotsAtSelectedTime: TimeSlot[];
}) => {
  const { servicesInView, serviceVariantsMap, filterOptions } = state;
  const { experiments, bookingsSettings } = context;

  const isBookFlowSettingsEnabled = isBookFlowSettingsEnabledUtil({
    experiments,
    bookingsSettings,
  });

  const resources = new Set(
    selectableSlotsAtSelectedTime
      .map((slot) => getStaffList(slot).map((resource) => resource.id))
      .flat(),
  );
  const hasMultipleStaffMembers = resources.size > 1;
  const hasNoStaffFilter = !filterOptions[FilterTypes.STAFF_MEMBER].length;
  const allServicesWithoutStaffVariant = servicesInView.every(
    (service) => !isServiceVariantWithStaff(serviceVariantsMap[service.id!]),
  );

  if (isBookFlowSettingsEnabled) {
    return (
      isAppointmentService(servicesInView[0]) &&
      hasMultipleStaffMembers &&
      hasNoStaffFilter &&
      allServicesWithoutStaffVariant &&
      !isCustomerMustChooseStaff(bookingsSettings!)
    );
  }

  return (
    !filterOptions[FilterTypes.STAFF_MEMBER].length &&
    resources.size > 1 &&
    servicesInView.every(
      (service) =>
        !isServiceVariantWithStaff(serviceVariantsMap[service.id!]) &&
        isServiceAutoAssignResourceAllowed(service),
    )
  );
};
